<!--
  ~ Copyright (C) 2026 - Potentially Ltd
  ~
  ~ Please see distribution for license.
-->

<div class="unsplash-search">
  <ptl-busy-overlay class="unsplash-search__busy" [active]="isDownloading()" [spinner]="true"></ptl-busy-overlay>

  <div class="unsplash-search__bar">
    <ptl-search
      class="unsplash-search__input"
      [value]="searchTerm()"
      [placeholder]="initialPhrase() || ('translations.imageUploadV3.searchPlaceholder' | transloco)"
      (valueChange)="onSearchChange($event)"
    ></ptl-search>
    <ng-content select="[searchAction]"></ng-content>
  </div>

  @if (isLoading()) {
    <div class="unsplash-search__grid">
      @for (tile of skeletonTiles; track tile) {
        <div class="unsplash-search__skeleton"></div>
      }
    </div>
  } @else if (hasError()) {
    <ptl-v3-empty-state
      class="unsplash-search__state"
      [icon]="LucideImageOff"
      [title]="'translations.errors.unableToLoadImage' | transloco"
      [description]="'translations.global.input.error.tryAgainDifferentTerm' | transloco"
    ></ptl-v3-empty-state>
  } @else if (showNoResults) {
    <ptl-v3-empty-state
      class="unsplash-search__state"
      [icon]="LucideSearchX"
      [title]="'translations.global.search.label.noResultsFound' | transloco"
      [description]="'translations.global.input.error.tryAgainDifferentTerm' | transloco"
    ></ptl-v3-empty-state>
  } @else if (showStartPrompt) {
    <ptl-v3-empty-state
      class="unsplash-search__state"
      [icon]="LucideImage"
      [title]="'translations.imageUploadV3.emptyTitle' | transloco"
      [description]="'translations.imageUploadV3.emptyDescription' | transloco"
    ></ptl-v3-empty-state>
  } @else if (hasPhotos) {
    <div class="unsplash-search__grid">
      @for (photo of visiblePhotos; track photo.id) {
        <div class="unsplash-search__tile">
          <button type="button" class="unsplash-search__thumb" (click)="selectPhoto(photo)">
            <img [src]="photo.urls.small" [alt]="photoAlt(photo)" />
          </button>
          <div class="unsplash-search__credit">
            <a class="unsplash-search__author fs-body-s" [href]="authorLink(photo)" target="_blank" rel="noopener noreferrer">{{
              authorName(photo)
            }}</a>
          </div>
        </div>
      }
    </div>

    @if (canShowMore) {
      <div class="unsplash-search__footer">
        <ptl-button
          type="link-color"
          size="m"
          [loading]="isLoadingMore()"
          [iconSuffix]="LucideChevronDown"
          [text]="'translations.global.button.seeMore' | transloco"
          (clicked)="showMore()"
        ></ptl-button>
      </div>
    }
  }
</div>
